import React, { useState } from 'react';

import { User, UserReplacement } from '@Types/index';
import EmployeeSelect from '@Components/EmployeeSelector/EmployeeSelect';
import { useGetEmpPhotoQuery } from '@Store/api/dictionaryApiSlice';

import MAvatar from '../Avatar/Avatar';
import styles from './select-employee-card.module.css';

interface ChosenUserCardProps {
  user?: {
    name: string;
    occupation: string;
  };
  onClick: () => void;
}

const ChosenUserCard: React.FC<ChosenUserCardProps> = ({ user, onClick }) => {
  if (!user) {
    return (
      <div className={styles.noSelectedUser} onClick={onClick}>
        <span>Click Here to Select Employee</span>
      </div>
    );
  }

  return (
    <>
      <div className={styles.userInfo}>
        <span className={styles.userName}> {user.name}</span>
        <span className={styles.userOccupation}>{user.occupation}</span>
      </div>
      <div className={styles.actionButton} onClick={onClick}>
        Change
      </div>
    </>
  );
};

interface SelectEmployeeCardProps {
  setValueToFormik: (
    userName: string,
    userNumber: string,
    occupation: string,
    photo: string | null
  ) => void;
  user?: {
    name: string;
    occupation: string;
    empImageName: string | null;
  };
  listOfUsers: UserReplacement[];
  onSearch: (searchValue: string) => void;
  onLoadMore: () => void;
}

const SelectEmployeeCard: React.FC<SelectEmployeeCardProps> = ({
  setValueToFormik,
  user,
  listOfUsers,
  onLoadMore,
  onSearch,
}) => {
  const [open, setIsOpen] = useState(false);
  const { data: userPhoto } = useGetEmpPhotoQuery(user?.empImageName || '');

  const handleClick = (): void => {
    setIsOpen(true);
  };

  const handleClose = (): void => {
    setIsOpen(false);
  };

  const handleSelectUser = (
    selectedUser: User | UserReplacement | null
  ): void => {
    if (selectedUser) {
      setValueToFormik(
        selectedUser.empName,
        selectedUser.empNumber,
        selectedUser.occupation,
        selectedUser.empImageName
      );
      handleClose();
    }
  };

  const handleSearch: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const searchString = event.target.value;
    onSearch(searchString);
  };

  return (
    <div className={styles.wrapper}>
      <div>
        <MAvatar size={48} src={userPhoto} />
      </div>
      <ChosenUserCard user={user} onClick={handleClick} />
      <EmployeeSelect
        title="Select Employee"
        isOpen={open}
        onClose={handleClose}
        onSearchChange={handleSearch}
        onUserSelect={handleSelectUser}
        users={listOfUsers}
        onLoadMore={onLoadMore}
      />
    </div>
  );
};

export default SelectEmployeeCard;
